export class SharedBuyerAddModel{
    public eventId: Array<number>;
    public buyerId:Array<string>;
    constructor(){
        this.eventId= new Array<number>();
        this.buyerId = new Array<string>();
    }
}